import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Button, Input } from "../../components/DesignSystem";
import { onlyNumberAndSixDigits } from "../../constants/validate";
import logoVibraSvg from "../../assets/logo-vibra.svg";
import logoVibraPng from "../../assets/logo-vibra.png";

import "./index.scss";
import axios from "axios";

export default function FirstAccess({ isLoading, goToNext, signInError }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [step, setStep] = useState(1);
  const [submitError, setSubmitError] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  useEffect(() => {
    if (goToNext) {
      setStep(2);
    }

    if (signInError) {
      setSubmitError(signInError);
    }
  }, [goToNext, signInError]);

  function handleCheckCredentials(event) {
    event.preventDefault();
    setIsLoadingSubmit(true);

    axios
      .post("/auth/verify-code", { email, code })
      .then((response) => {
        const { data } = response;
        dispatch({ type: "CHANGE_USER", payload: data });
        axios.defaults.headers.common["token"] = data.token;
        localStorage.setItem("user", JSON.stringify(data));
        setIsLoadingSubmit(false);
        setStep(2);
      })
      .catch((e) => {
        switch (e.response.status) {
          case 403:
            setSubmitError(
              'Detectamos que você já acessou a plataforma antes. Por favor, clique em "Faça login" e insira seus dados novamente.'
            );
            break;
          case 401:
            setSubmitError("Credenciais incorretas");
            break;
          default:
            setSubmitError("Houve um erro inesperado");
            break;
        }

        setIsLoadingSubmit(false);
      });
  }

  function handleGoToLogin() {
    navigate("/login");
  }

  function handleGoToResendCode() {
    navigate("/reenviar-codigo");
  }

  function handleRedefinePassword(event) {
    event.preventDefault();
    if (password !== confirmPassword) {
      setSubmitError("As senhas precisas ser iguais");
    } else {
      changePassword();
    }
  }

  function changePassword() {
    setIsLoadingSubmit(true);
    axios
      .put("user/change-password", { password, email, firstAccess: true })
      .then((response) => {
        setIsLoadingSubmit(false);
        navigate("/caso");
      })
      .catch((err) => {
        setSubmitError("Ocorreu erro, tente novamente.");
        console.log(err);
        setIsLoadingSubmit(false);
      });
  }

  return (
    <div className="first-access">
      <section>
        <header>
          <div className="first-access__logo">
            <picture>
              <source type="image/svg+xml" srcSet={logoVibraSvg} />
              <img src={logoVibraPng} alt="Vibra" />
            </picture>
          </div>
        </header>
        {step === 1 && (
          <form
            className="first-access__form"
            onSubmit={handleCheckCredentials}
          >
            <div className="first-access__form__header">
              <span>Passo 1 de 2</span>
              <h3>Primeiro acesso ao Pagdeal</h3>
              <p>Por favor, preencha os campos abaixo</p>
            </div>
            <div className="first-access__form__main">
              <Input
                label="Email"
                placeholder=""
                type="email"
                value={email}
                onChange={setEmail}
                required
              />
              <Input
                label="Código enviado por email"
                placeholder=""
                type="text"
                value={onlyNumberAndSixDigits(code)}
                onChange={setCode}
                required
              />
              <Button
                type="submit"
                contained
                disabled={isLoadingSubmit || isLoading}
                loading={isLoadingSubmit || isLoading}
                style={{ width: "100%" }}
              >
                Continuar
              </Button>
              <div
                className={
                  submitError
                    ? "first-access__form__error first-access__form__error--visible"
                    : "first-access__form__error"
                }
                dangerouslySetInnerHTML={{ __html: submitError }}
              />
            </div>
            <div className="first-access__form__footer">
              <p>Já acessou a plataforma antes?</p>
              <button type="button" onClick={handleGoToLogin}>
                Faça login
              </button>
              <p className="first-access__form__footer__resend-code">Não recebeu o código?</p>
              <button type="button" onClick={handleGoToResendCode}>
                Reenviar código
              </button>
            </div>
          </form>
        )}
        {step === 2 && (
          <form
            className="first-access__form"
            onSubmit={handleRedefinePassword}
          >
            <div className="first-access__form__header">
              <span>Passo 2 de 2</span>
              <h3>Defina sua senha</h3>
              <p>
                Você usará essa senha para entrar no Pagdeal quando for
                necessário.
              </p>
            </div>
            <div className="first-access__form__main">
              <Input
                label="Senha"
                placeholder=""
                type="password"
                value={password}
                onChange={setPassword}
                required
              />
              <Input
                label="Repita sua senha"
                placeholder=""
                type="password"
                value={confirmPassword}
                onChange={setConfirmPassword}
              />
              <div
                className={
                  submitError
                    ? "first-access__form__error first-access__form__error--visible"
                    : "first-access__form__error"
                }
                dangerouslySetInnerHTML={{ __html: submitError }}
              />
              <Button
                type="submit"
                contained
                disabled={isLoadingSubmit}
                loading={isLoadingSubmit}
                style={{ width: "100%" }}
              >
                Continuar
              </Button>
            </div>
          </form>
        )}
        <footer>
          Ao fazer login você concorda com a nossa{" "}
          <a href="#" target="_blank">
            Política de privacidade.
          </a>
          .
        </footer>
      </section>
      <div className="first-access__image">
        {/* NASDAQ 2025
        <span role="img" aria-label="rocket">🚀</span> */}
      </div>
    </div>
  );
}
